// extracted by mini-css-extract-plugin
export default {"graphic":"LoadingGraphic-LoadingGraphic-module__graphic--sTh18","reversed":"LoadingGraphic-LoadingGraphic-module__reversed--Xw3Hh"};